<sf-loader></sf-loader>
<sf-notification></sf-notification>
<div class="p-grid">
    <div class="p-col-12" style="margin-top: -22px;">
        <p-table #dt [value]="list" dataKey="id" [paginator]="true" [rows]="15"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="pageMessage"
            [rowsPerPageOptions]="[15,50,100]"
            [globalFilterFields]="['telephone', 'email', 'message', 'dateReceived']"
            styleClass="p-datatable-responsive-demo p-datatable-striped"  [showCurrentPageReport]="true">

            <ng-template pTemplate="caption">
                <div class="flex">
                    <button pButton pRipple icon="pi pi-plus" [label]="'message.new_message' | translate" class="p-button-primary p-mr-2" style="width: 180px;"
                    (click)="addItem()" *ngIf="flUpdate"></button>

                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <!-- <input #filter pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"  [placeholder]="'search.role' | translate" /> -->
                        <button pButton [label]="'button.clear' | translate" class="p-button-warning mr-2 ml-2" icon="pi pi-filter-slash" (click)="clear(dt, filter); filter.value = '';"></button>
                    </span>
                    <p-button icon="pi pi-refresh" (click)="getList()"></p-button>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>                    
                    <th style="text-align: center;"><span translate>label.telephone</span></th>
                    <th style="text-align: center;"><span translate>label.email</span></th>
                    <th style="text-align: center;"><span translate>label.message</span></th>
                    <th style="text-align: center;"><span translate>label.date</span></th>                    
                    <!-- <th style="width: 260px; text-align: center;"><span translate>label.actions</span></th> -->
                </tr>
                <tr>
                    <th></th>

                    <th><input pInputText type="text" (input)="dt.filter($event.target.value, 'telephone', 'contains')" class="w-full"/></th>
                    <th><input pInputText type="text" (input)="dt.filter($event.target.value, 'email', 'contains')" class="w-full"/></th>
                    <th><input pInputText type="text" (input)="dt.filter($event.target.value, 'message', 'contains')" class="w-full"/></th>
                    <th></th>                    
                    <!-- <th></th> -->
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
                <tr>                    
                    <td style="text-align: left;">{{item.telephone}}</td>
                    <td style="text-align: left;">{{item.email}}</td>                    
                    <td style="text-align: left;">{{item.message | safeHtml}}</td>                    
                    <td style="text-align: left;">{{item.dateReceived}}</td>
                    
                    <!-- <td style="text-align: center;">
                        <p-button icon="pi pi-pencil" [styleClass]="classBtnUpd" [pTooltip]="'button.edit' | translate" (click)="updItem(item.id)"></p-button>
                        <p-button icon="pi pi-key" [styleClass]="classBtnReset" [pTooltip]="'button.reset_pwd' | translate" (click)="resetPwd(usuario)" [disabled]="!flUpdate"></p-button>
                        <p-button icon="pi pi-trash" [styleClass]="classBtnDel" [pTooltip]="'button.delete' | translate"   (click)="delItem(item)" [disabled]="!flUpdate"></p-button>
                    </td> -->
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>